import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Pick your bundle",
    body: "Choose 1 to 6 pillows in Queen or King. The more you bundle, the more you save.",
    visual: (
      <div className="bg-white border border-black/5 rounded-2xl p-5 shadow-md flex items-center gap-3">
        <span className="bg-[#d8f06b] text-[#0e0e10] font-bold px-3 py-1.5 rounded-full text-[12px]">
          Save $139
        </span>
        <span className="font-bold">2 pillows · $299</span>
      </div>
    ),
  },
  {
    n: "02",
    title: "Free express shipping",
    body: "We process your order in our warehouse within 24–48 hours. Delivered worldwide in 5–7 days, fully tracked and signed for.",
    visual: (
      <div className="bg-white border border-black/5 rounded-2xl p-5 shadow-md">
        <div className="flex items-center justify-between mb-3">
          <span className="text-[12px] font-semibold uppercase tracking-wider text-[#6b6b72]">
            Tracking
          </span>
          <span className="text-[11px] bg-[#22c55e]/15 text-[#16a34a] font-bold px-2 py-0.5 rounded-full">
            ✓ Shipped
          </span>
        </div>
        <div className="text-[14px] font-mono">DXB → LON → NYC</div>
        <div className="mt-2 h-1.5 rounded-full bg-[#ececec] overflow-hidden">
          <div className="h-full w-3/4 bg-[#4a6cff] rounded-full" />
        </div>
      </div>
    ),
  },
  {
    n: "03",
    title: "Sleep, finally",
    body: "First night you'll know. By night 30, you won't remember sleeping without it. Or your money back.",
    visual: (
      <div className="bg-white border border-black/5 rounded-2xl p-5 shadow-md">
        <div className="text-[11px] uppercase tracking-wider text-[#6b6b72] mb-2">
          Sleep Score
        </div>
        <div className="flex items-baseline gap-2">
          <span className="text-[32px] font-black">94</span>
          <span className="text-[12px] text-[#22c55e] font-bold">+47%</span>
        </div>
        <div className="text-[11px] text-[#8a8a8a] mt-1">
          Avg. after 7 nights with Dubai Pillow
        </div>
      </div>
    ),
  },
];

export default function HowItWorksV2() {
  return (
    <section id="how" className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center">
          <h2 className="text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            From order to deep sleep
            <br />
            <span className="inline-flex items-center gap-2">
              <span className="text-[#8a8a8a]">⏱ in under</span>
              <span className="sticker sticker-lime">10 days</span>
            </span>
          </h2>
        </div>

        <div className="mt-16 max-w-3xl mx-auto relative">
          <div className="absolute left-[34px] md:left-[42px] top-0 bottom-0 w-px bg-[#ececec]" />
          <div className="space-y-14 md:space-y-20">
            {STEPS.map((s) => (
              <div key={s.n} className="grid grid-cols-[70px_1fr] md:grid-cols-[88px_1fr_280px] gap-4 md:gap-8 items-start">
                <div className="font-black text-[42px] md:text-[56px] leading-none text-[#c9a8ff]/70 select-none">
                  {s.n}
                </div>
                <div>
                  <h3 className="text-[22px] md:text-[26px] font-black text-[#0e0e10]">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[#5a5a60] text-[14px] md:text-[15px] leading-relaxed max-w-md">
                    {s.body}
                  </p>
                </div>
                <div className="col-span-2 md:col-span-1">{s.visual}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
